module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand1_m.bc8d72e1b94d5401ff8e28f21bb1bed7.png";